export const HOME = {
  emergentLink: 'home-emergent-link',
};

export const AUTH = {
  loginForm: 'auth-login-form',
  loginEmail: 'auth-login-email',
  loginPassword: 'auth-login-password',
  loginSubmit: 'auth-login-submit',
  registerForm: 'auth-register-form',
  registerEmail: 'auth-register-email',
  registerPassword: 'auth-register-password',
  registerName: 'auth-register-name',
  registerSubmit: 'auth-register-submit',
};

export const DASHBOARD = {
  container: 'dashboard-container',
  totalCampaigns: 'dashboard-total-campaigns',
  totalAssets: 'dashboard-total-assets',
  totalCustomers: 'dashboard-total-customers',
};

export const CAMPAIGNS = {
  listContainer: 'campaigns-list-container',
  campaignCard: 'campaign-card',
  createButton: 'campaigns-create-button',
  filterTrade: 'campaigns-filter-trade',
  searchInput: 'campaigns-search-input',
};

export const CAMPAIGN_DETAIL = {
  container: 'campaign-detail-container',
  assetCard: 'campaign-asset-card',
  editButton: 'campaign-edit-button',
};
